import { BasicInfo } from "@/types/dto/common/basic-info";
import { FAQSection } from "@/types/dto/destinations-page/destination-page-types";
import {
  Accommodation
  // KeyInformation,
  // KeyInformationHeader,
  // KeyInformationSection,
  // KeyInformationContent
} from "@/types/dto/pdp/pdp-accomodations-key-information";

export const accommodationFactory = (data: any = {}): Accommodation => ({
  night: data?.night ?? "",
  price: data?.price ?? "",
  hotelName: data?.hotelName ?? "",
  city: data?.city ?? "",
  country: data?.country ?? "",
  imageUrl: data?.imageUrl ?? "",
  imageAlt: data?.imageAlt ?? ""
});

// export const keyInformationContentFactory = (data: any = {}): KeyInformationContent => ({
//   id: data?.id ?? 0,
//   title: data?.title ?? "",
//   text: data?.text ?? ""
// });

// export const keyInformationSectionFactory = (data: any = {}): KeyInformationSection => ({
//   sectionTitle: data?.sectionTitle ?? "",
//   content: data?.content?.map((item: any) => keyInformationContentFactory(item)) ?? []
// });

// export const keyInformationHeaderFactory = (data: any = {}): KeyInformationHeader => ({
//   title: data?.title ?? "",
//   description: data?.description ?? ""
// });

// export const keyInformationFactory = (data: any = {}): KeyInformation => ({
//   header: keyInformationHeaderFactory(data?.header),
//   sections: data?.sections?.map((section: any) => keyInformationSectionFactory(section)) ?? []
// });

const SECTION_TITLES: Record<string, string> = {
  documentNotes: "What to Expect",
  travelRequirements: "Travel Requirements",
  travelTips: "Getting Ready to Travel"
};

export const keyInformationFactory = (data: any): FAQSection[] => {
  const keyInformationData = Object.entries(data).map(
    (section): FAQSection => ({
      basicInfo: { headerText: SECTION_TITLES[section[0]] ?? section[0] ?? "Untitled Section" },
      faqs: Array.isArray(section[1])
        ? section[1].map((faq) => ({
            id: faq?.title ?? "No ID",
            question: faq?.title ?? "No Question",
            answer: faq?.content ?? "No Answer Available"
          }))
        : []
    })
  );
  return keyInformationData;
};

export const keyInformationHeaderFactory = (data: any): BasicInfo => ({
  callToActionText: data?.callToActionText ?? "",
  callToActionUrl: data?.callToActionUrl ?? "",
  headerText: data?.headerText ?? "",
  copyText: data?.copyText ?? ""
});
